import { render, staticRenderFns } from "./SingleTest.vue?vue&type=template&id=096b8f8a&scoped=true&"
import script from "./SingleTest.vue?vue&type=script&lang=js&"
export * from "./SingleTest.vue?vue&type=script&lang=js&"
import style0 from "./SingleTest.vue?vue&type=style&index=0&id=096b8f8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096b8f8a",
  null
  
)

export default component.exports